import React, { Fragment } from 'react'

import PropTypes from 'prop-types'

import './cards.css'

const Cards = (props) => {
  const TitleTag = props.titleAs
  return (
    <div className={`cards-container ${props.rootClassName} `}>
      <TitleTag className="cards-text1 H1_large">
        {props.heading1 ?? (
          <Fragment>
            <span className="cards-text4">Серия MX Pulse</span>
          </Fragment>
        )}
      </TitleTag>
      <span className="cards-text2 H1_small">
        {props.text1 ?? (
          <Fragment>
            <span className="cards-text3">
              Цифровые источники MIG/MAG с импульсным режимом для
              высококачественной сварки стали, нержавеющей стали и алюминия.
            </span>
          </Fragment>
        )}
      </span>
    </div>
  )
}

Cards.defaultProps = {
  text1: undefined,
  heading1: undefined,
  rootClassName: '',
  titleAs: 'h2',
}

Cards.propTypes = {
  text1: PropTypes.element,
  heading1: PropTypes.element,
  rootClassName: PropTypes.string,
  titleAs: PropTypes.string,
}

export default Cards
